export const sortableColumns = {
    date: 'date'
};
